<template>
  <div>
    <el-card class="box-card">
      <!-- 说明 -->
      <el-alert title="此页面配置全局卡券模板(卡名称/有效期/骑行险产品),各运营商的价格/押金/骑行险金额请在「运营商卡券配置」页面设置" type="info" :closable="false" style="margin-bottom: 15px;"></el-alert>

      <!-- 搜索区域 -->
      <div style="margin-bottom: 20px;">
        <el-form :inline="true" size="small" label-width="80px">
          <el-form-item label="运营商:">
            <el-select v-model="queryReq.distributorId" clearable placeholder="全部" style="width: 200px;">
              <el-option v-for="item in distributorOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="卡类型:">
            <el-select v-model="queryReq.cardType" clearable placeholder="全部" style="width: 120px;">
              <el-option label="日卡" :value="1"></el-option>
              <el-option label="周卡" :value="2"></el-option>
              <el-option label="月卡" :value="3"></el-option>
              <el-option label="自定义" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="reGetList">查询</el-button>
            <el-button type="success" @click="openAddDialog">+ 添加卡券模板</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <el-table :data="cardList" border stripe :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column label="运营商" width="150">
          <template slot-scope="scope">{{ distributorNameMap[scope.row.distributorId] || scope.row.distributorName || '全局模板' }}</template>
        </el-table-column>
        <el-table-column label="卡名称" prop="cardName"></el-table-column>
        <el-table-column label="卡类型">
          <template slot-scope="scope">
            <el-tag :type="cardTypeTag(scope.row.cardType)">{{ cardTypeText(scope.row.cardType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="有效小时数" width="110">
          <template slot-scope="scope">{{ scope.row.validHours != null ? scope.row.validHours : (scope.row.validDays != null ? scope.row.validDays + '天' : '-') }}</template>
        </el-table-column>
        <el-table-column label="适用范围" width="150">
          <template slot-scope="scope">
            {{ bicycleTypeText(scope.row.bicycleType) }}{{ scope.row.deviceTypeName ? ' / ' + scope.row.deviceTypeName : (scope.row.deviceTypeCode && scope.row.deviceTypeCode !== 'ALL' ? ' / ' + scope.row.deviceTypeCode : '') }}
          </template>
        </el-table-column>
        <el-table-column label="含骑行险">
          <template slot-scope="scope">
            <el-tag :type="scope.row.insuranceEnabled == 1 ? 'success' : 'info'" size="small">
              {{ scope.row.insuranceEnabled == 1 ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="保险产品" prop="insuranceProductNo" width="120">
          <template slot-scope="scope">
            {{ scope.row.insuranceProductNo || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="sortOrder" width="60"></el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button v-if="isSuperAuthority" size="mini" type="danger" icon="el-icon-delete" @click="deleteCard(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryReq.page" :page-sizes="[8, 15, 25, 50]"
        :page-size="queryReq.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700px" @close="resetForm">
      <el-form :model="formData" :rules="formRules" ref="cardForm" label-width="130px" size="small">
        <el-row>
          <el-col :span="12">
            <el-form-item label="运营商" prop="distributorId">
              <el-select v-model="formData.distributorId" filterable placeholder="请选择运营商" style="width: 100%;" @change="onDialogDistributorChange">
                <el-option v-for="item in distributorOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卡类型" prop="cardType">
              <el-select v-model="formData.cardType" placeholder="请选择" style="width: 100%;" @change="onCardTypeChange">
                <el-option label="日卡" :value="1"></el-option>
                <el-option label="周卡" :value="2"></el-option>
                <el-option label="月卡" :value="3"></el-option>
                <el-option label="自定义" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="卡名称" prop="cardName">
              <el-input v-model.trim="formData.cardName" placeholder="如: 日卡/周卡/季卡/自定义名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效小时数" prop="validHours">
              <el-input-number v-model="formData.validHours" :min="1" :max="8760" style="width: 100%;" placeholder="如: 日卡=24,周卡=168"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="车锁类型" prop="bicycleType">
              <el-select v-model="formData.bicycleType" placeholder="请选择车锁类型" style="width: 100%;" @change="onBicycleTypeChange">
                <el-option label="自行车锁" :value="1"></el-option>
                <el-option label="电动车锁" :value="2"></el-option>
                <el-option label="涨闸锁自行车" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="sortOrder">
              <el-input-number v-model="formData.sortOrder" :min="0" :max="999" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">骑行险配置</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="包含骑行险">
              <el-switch v-model="formData.insuranceEnabled" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.insuranceEnabled == 1">
          <el-col :span="12">
            <el-form-item label="保险产品编号" prop="insuranceProductNo">
              <el-input v-model.trim="formData.insuranceProductNo" placeholder="如: P002/P003/P004"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保险公司分账(元)" prop="companySplitAmount">
              <el-input-number v-model="formData.companySplitAmount" :precision="2" :min="0" :step="0.1" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">适用车辆类型</el-divider>
        <el-form-item label="车辆类型" prop="deviceTypeCode">
          <el-select v-model="formData.deviceTypeCode" filterable placeholder="请选择车辆类型" style="width: 100%;" :disabled="!formData.distributorId">
            <el-option v-for="item in deviceTypeOptions" :key="item.deviceTypeCode"
                       :label="item.deviceTypeName" :value="item.deviceTypeCode"></el-option>
          </el-select>
          <div style="color:#909399;font-size:12px;">请先选择运营商,再选择该运营商的车辆类型</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-if="isSuperAuthority" type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryReq: { page: 1, limit: 8, distributorId: '', cardType: null },
      cardList: [],
      total: 0,
      distributorOptions: [],
      distributorNameMap: {},
      deviceTypeOptions: [],
      dialogVisible: false,
      isEdit: false,
      formData: {
        id: null, distributorId: '', cardType: 1, cardName: '',
        validDays: null, validHours: 24,
        insuranceEnabled: 1, insuranceProductNo: 'P002', companySplitAmount: 0,
        deviceTypeCode: '', bicycleType: null, sortOrder: 0
      },
      formRules: {
        distributorId: [{ required: true, message: '请选择运营商', trigger: 'change' }],
        cardType: [{ required: true, message: '请选择卡类型', trigger: 'change' }],
        cardName: [{ required: true, message: '请输入卡名称', trigger: 'blur' }],
        validHours: [{ required: true, message: '请输入有效小时数', trigger: 'blur' }],
        bicycleType: [{ required: true, message: '请选择车锁类型', trigger: 'change' }],
        deviceTypeCode: [{ required: true, message: '请选择车辆类型', trigger: 'change' }]
      },
      isSuperAuthority: false
    }
  },
  computed: {
    dialogTitle() { return this.isEdit ? '编辑卡券模板' : '添加卡券模板'; }
  },
  created() {
    this.initCurrentRoleCode();
    this.getDistributorOptions();
    this.getList();
  },
  methods: {
    initCurrentRoleCode() {
      const roleCodes = JSON.parse(window.sessionStorage.getItem('roleCodes') || '[]');
      const roles = JSON.parse(window.sessionStorage.getItem('roles') || '[]');
      this.isSuperAuthority = roleCodes.includes('SUPER_AUTHORITY') || roles.some(role => role.roleCode === 'SUPER_AUTHORITY');
    },
    async getDistributorOptions() {
      const { data: res } = await this.$http.get('/distributor/manager/getAllDistributorInfo');
      if (res.code == 200) {
        this.distributorOptions = res.data;
        const map = {};
        res.data.forEach(item => { map[item.id] = item.name; });
        this.distributorNameMap = map;
      }
    },
    async getList() {
      const { data: res } = await this.$http.get('/passCard/list', { params: this.queryReq });
      if (res.code != 200) return this.$message.error(res.msg);
      this.cardList = res.data.list;
      this.total = res.data.total;
    },
    reGetList() { this.queryReq.page = 1; this.getList(); },
    handleSizeChange(val) { this.queryReq.limit = val; this.getList(); },
    handleCurrentChange(val) { this.queryReq.page = val; this.getList(); },
    cardTypeText(type) { return { 1: '日卡', 2: '周卡', 3: '月卡', 4: '自定义' }[type] || '-'; },
    cardTypeTag(type) { return { 1: '', 2: 'success', 3: 'warning', 4: 'info' }[type] || ''; },
    bicycleTypeText(type) { return { 1: '自行车锁', 2: '电动车锁', 3: '涨闸锁' }[type] || '-'; },
    // 加载某运营商的车辆类型列表(按车锁类型过滤)
    async loadDeviceTypes(distributorId, bicycleType) {
      if (!distributorId) {
        this.deviceTypeOptions = [];
        return;
      }
      const params = { distributorId: distributorId };
      if (bicycleType) {
        params.bicycleType = bicycleType;
      }
      try {
        const { data: res } = await this.$http.get('/device/typeConfig/list', { params });
        if (res.code == 200) {
          this.deviceTypeOptions = res.data || [];
        }
      } catch (e) {
        console.error('加载车辆类型失败', e);
      }
    },
    // 弹框中切换运营商时清空车辆类型并重新加载(带当前车锁类型)
    onDialogDistributorChange(val) {
      this.formData.deviceTypeCode = '';
      this.loadDeviceTypes(val, this.formData.bicycleType);
    },
    // 选择车锁类型时,清空已选车辆类型并按车锁类型过滤重新加载
    onBicycleTypeChange() {
      this.formData.deviceTypeCode = '';
      this.loadDeviceTypes(this.formData.distributorId, this.formData.bicycleType);
    },
    onCardTypeChange(val) {
      const hoursMap = { 1: 24, 2: 168, 3: 720 };
      const productMap = { 1: 'P002', 2: 'P003', 3: 'P004' };
      if (hoursMap[val] != null) {
        this.formData.validHours = hoursMap[val];
      }
      if (productMap[val] && (!this.formData.insuranceProductNo || this.formData.insuranceProductNo.startsWith('P00'))) {
        this.formData.insuranceProductNo = productMap[val];
      }
    },
    openAddDialog() {
      this.isEdit = false;
      this.resetForm();
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.isEdit = true;
      this.formData = JSON.parse(JSON.stringify(row));
      // 兼容旧数据:validHours 为空时用 validDays*24 预填
      if (this.formData.validHours == null && this.formData.validDays != null) {
        this.formData.validHours = this.formData.validDays * 24;
      }
      // 编辑回显时加载该运营商该车辆类型的车辆类型列表
      if (this.formData.distributorId) {
        this.loadDeviceTypes(this.formData.distributorId, this.formData.bicycleType);
      }
      this.dialogVisible = true;
    },
    resetForm() {
      this.formData = {
        id: null, distributorId: '', cardType: 1, cardName: '',
        validDays: null, validHours: 24,
        insuranceEnabled: 1, insuranceProductNo: 'P002', companySplitAmount: 0,
        deviceTypeCode: '', bicycleType: null, sortOrder: 0
      };
      this.deviceTypeOptions = [];
      if (this.$refs.cardForm) this.$refs.cardForm.clearValidate();
    },
    submitForm() {
      this.$refs.cardForm.validate((valid) => {
        if (!valid) return;
        // validHours 同步到 validDays(兼容旧逻辑)
        if (this.formData.validHours != null) {
          this.formData.validDays = Math.floor(this.formData.validHours / 24);
        }
        const url = this.isEdit ? '/passCard/update' : '/passCard/add';
        this.$http.post(url, this.formData).then((res) => {
          if (res.data.code != 200) return this.$message.error(res.data.msg);
          this.dialogVisible = false;
          this.reGetList();
          this.$message.success(res.data.msg);
        });
      });
    },
    deleteCard(id) {
      this.$confirm('确定删除此卡券模板吗？删除后不可恢复。', '警告', { type: 'warning' }).then(() => {
        this.$http.post('/passCard/delete', null, { params: { id } }).then((res) => {
          if (res.data.code != 200) return this.$message.error(res.data.msg);
          this.$message.success(res.data.msg);
          this.reGetList();
        });
      }).catch(() => {});
    }
  }
}
</script>
